export const PREFIX = 'movie_';
/**
 * @param name
 * @param content
 * @param duration Time
 * @param set_time 
 * @returns {boolean}
 */
export const setStore = (name, content, set_time = false, duration = 15) => {
    if (!name) return false;
    name = PREFIX + name;
    if (typeof content !== 'string') {
        content = JSON.stringify(content)
    }
    if (set_time) {
        let date = new Date;
        if (duration > 0) {
            content += '&' + (date.getTime() + duration * 3600 * 1e3)
        } else {
            content += '&0'
        }
        content += '&' + (date.getTime())
    }
    window.localStorage.setItem(name, content)
};

/**
 * @param name
 * @param parse 
 * @returns {boolean}
 */
export const getStore = (name, parse = false) => {
    if (!name) return false;
    name = PREFIX + name;
    if (parse) {
        return JSON.parse(window.localStorage.getItem(name))
    }
    return window.localStorage.getItem(name)
};

/**
 */
export const removeStore = name => {
    if (!name) return false;
    name = PREFIX + name;
    window.localStorage.removeItem(name)
};

/**
 * @param name 
 * @param value 
 * @param duration 
 */
export const addCookie = (name, value, duration) => {
    name = PREFIX + name;
    let n = name + '=' + escape(value) + '; path=/';
    if (duration > 0) {
        let date = new Date;
        date.setTime(date.getTime() + duration * 3600 * 1e3);
        n = n + ';expires=' + date.toGMTString()
    }
    document.cookie = n
};

/**
 * @param name cookie
 * @returns {null}
 */
export const getCookie = (name) => {
    name = PREFIX + name;
    let t = document.cookie;
    let a = t.split('; ');
    for (let n = 0; n < a.length; n++) {
        let r = a[n].split('=');
        if (r[0] === name) {
            return unescape(r[1])
        }
    }
    return null
};

/**
 * @param name 
 */
export const delCookie = (name) => {
    name = PREFIX + name;
    let t = new Date;
    t.setTime(t.getTime() - 1);
    let a = getCookie(name);
    if (a !== null) document.cookie = name + '=' + a + '; path=/;expires=' + t.toGMTString()
};


// WEBPACK FOOTER //
// ./src/utils/storage.js